import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetActionByFlowId = createAsyncThunk(
  "DropDowns/GetActionByFlowId",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetActionByFlowId",

        param
      );

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownActionByFlowId = createSlice({
  name: "DropDownActionByFlowId",
  initialState: {
    DropDownActionByFlowId: [],
    loadingDropDownActionByFlowId: false,
    errorDropDownActionByFlowId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetActionByFlowId.pending, (state, action) => {
        state.loadingDropDownActionByFlowId = true;
        state.DropDownActionByFlowId = action.payload;
        state.errorDropDownActionByFlowId = null;
      })
      .addCase(GetActionByFlowId.fulfilled, (state, action) => {
        state.loadingDropDownActionByFlowId = false;
        state.DropDownActionByFlowId = action.payload;
      })
      .addCase(GetActionByFlowId.rejected, (state, action) => {
        state.loadingDropDownActionByFlowId = false;
        state.errorDropDownActionByFlowId = action.payload;
      });
  },
});

export default DropDownActionByFlowId.reducer;
